/**
 * @Project Name: vue-admin
 * @Author: luichooy
 * @Date: 2017-11-15 10:09
 * @Email: luichooy@163.com
 * @Idea: WebStorm
 */

export default (function () {
    // const domain = 'http://192.168.31.245:8080';
    // const domain = 'https://game.litebike.cn';
    // const domain = 'https://bigelan.com';
    // const domain = 'http://www.bigelan.com';
    const domain = 'https://www.bigelan.com/index.php/';

    const http = {
        // login: domain + '/user/Secure/do_login',//登录
        exit: domain + '/user/Secure/quit',//退出
        changePwd: domain + '/user/Secure/update_pwd',//更新密码
        getTeamList: domain + '/user/Team/get_team_list',//获取球队列表
        getTeamMember: domain + '/user/Team/get_team_member',//获取球队人员列表
        // getAccountList: domain + '/user/Account/get_account_list',//获取账号列表
        getAccountType: domain + '/user/Account/get_account_type',//获取账号类型列表
        setAccount: domain + '/user/Account/set_account',//添加/修改账号
        delAccounts: domain + '/user/Account/del_accounts',//批量删除账号
        getDataStatistics: domain + '/user/Statistics/get_data_statistics',//获取数据统计
        getDataDetails: domain + '/user/Statistics/get_data_details',//获取数据详情
        statisticsExport: domain + '/user/Statistics/statistics_export',//数据统计导出
        statisticsDetailsExport: domain + '/user/Statistics/details_export',//数据详情导出
        getMatchList: domain + '/user/Match/get_match_list',//获取赛事列表
        matchExport: domain + '/user/Match/export',//赛事导出
        delMatches: domain + '/user/Match/del_matches',//批量删除赛事
        getRaceList: domain + '/user/Race/get_race_list',//获取比赛列表
        getRoundList: domain + '/user/Mainer/get_round_list',//获取轮次列表
        delRaces: domain + '/user/Race/del_races',//批量删除比赛
        raceExport: domain + '/user/Race/export',//比赛导出
        getMatchGroups: domain + '/user/Match/get_match_groups',//获取赛事组别 matchid）
        setRound: domain + '/user/Mainer/set_round',//添加/修改轮次
        getEnrollList: domain + '/user/Enroll/get_enroll_list',//获取报名团队列表
        setEnroll: domain + '/user/Enroll/set_enroll',//修改报名状态
        enrollExport: domain + '/user/Enroll/export',//报名导出
        getMatchInfo: domain + '/user/Match/get_match_info',//获取赛事信息详情
        setRace: domain + '/user/Race/set_race',//添加/修改比赛
        getProjectList: domain + '/user/Mainer/get_project_list',//获取运动项目列表
        getGroupProTypeList: domain + '/user/Mainer/get_groupProType_list',//获取组别项目类型
        setMatch: domain + '/user/Match/set_match',//添加/修改赛事
        getGroupTrackList: domain + '/user/Mainer/get_groupTrack_list',//获取径赛项目类型
        getGroupFieldList: domain + '/user/Mainer/get_groupField_list',//获取田赛项目类型
        addGroupField: domain + '/user/Mainer/add_groupField',//添加田赛
        addGroupTrack: domain + '/user/Mainer/add_groupTrack',//添加径赛

        login: domain + 'Admin/Login',
        getAccountList: domain + 'GetAccountList',
        getAccountCount: domain + 'GetAccountCount',
        exportAccountList: domain + 'Match/CollegeExportSignUpList',
        confirmSignUpList: domain + 'Match/CollegeConfrimSignUpList',
        updateMyData: domain + 'UpdateMyData',
        getVideoUrl:'https://www.bigelan.com/upload/gdut_video/',


      // admin_id | admin_score





    };

    return {
        domain: domain,
        http: http
    }
})()



// WEBPACK FOOTER //
// ./src/api/api.js